export default __webpack_public_path__ + "static/media/add-student.fccbe63a.png";